<template>
  <div class="content">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>新增活动分发
    </div>
    <div class="set_wrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="分发活动名称">
          <el-input v-model="form.name" placeholder="请输入分发活动名称"></el-input>
        </el-form-item>
        <el-form-item label="分发成员">
          <el-button>选择成员</el-button>已选0人
        </el-form-item>
        <el-form-item label="落地页">
          <el-radio-group v-model="radio1">
            <el-radio label="名片"></el-radio>
            <el-radio label="商城 - 选择商品"></el-radio>
            <el-radio label="动态 - 选择动态"></el-radio>
            <el-radio label="官网"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button>取消</el-button>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <activityChoosemallDialog :visible.sync="choosemalldialog" v-if="choosemalldialog"></activityChoosemallDialog>
    <activityChooseTrendDialog :visible.sync="choosetrenddialog" v-if="choosetrenddialog"></activityChooseTrendDialog>
  </div>
</template>
<script>
import activityChooseMallDialog from "@/components/dialog/activityChooseMallDialog.vue";
import activityChooseTrendDialog from "@/components/dialog/activityChooseTrendDialog.vue";
export default {
  name: "activityAdd",
  components: {
    activityChooseMallDialog,
    activityChooseTrendDialog
  },
  data() {
    return {
      form: {
        choosemalldialog: false,
        choosetrenddialog: false
      },
      radio1: ""
    };
  },
  methods: {
    onSubmit() {
      // console.log("submit!");
    },
    goback() {
      this.$router.go(-1);
    },
    // 选择商品
    choosemall() {
      this.choosemalldialog = true;
    },
    // 选择动态
    choosetrend() {
      this.choosetrenddialog = true;
    }
  }
};
</script>